import React, { useState, useContext } from 'react';
import styled from 'styled-components';

const lv = (x) => {
  console.log(x);
  return x;
};
lv('hello');

const 简谱音名表 = [
  '1-', '#1-', '2-', '#2-', '3-', '4-', '#4-', '5-', '#5-', '6-', '#6-', '7-',
  '1', '#1', '2', '#2', '3', '4', '#4', '5', '#5', '6', '#6', '7',
  '1+', '#1+', '2+', '#2+', '3+', '4+', '#4+', '5+', '#5+', '6+', '#6+', '7+',
  '1++', '#1++', '2++', '#2++', '3++', '4++', '#4++', '5++', '#5++', '6++', '#6++', '7++',
];

const 十二 = ['C', '#C', 'D', '#D', 'E', 'F', '#F', 'G', '#G', 'A', '#A', 'B'];
const 基准音名表 = Array(10).fill().map(
  (_, index) => 十二.map(x => `${x}${index}`)
).reduce(
  (flat, row) => [...flat, ...row],
  [],
);
// const 中央C位置 = 基准音名表.findIndex('C4');

const 音名 = (筒音, 音, 音名表) => 音名表[音名表.findIndex(音名 => 音名 === 筒音) + 音 - 1];

const 指法数据 = [
  [1,   1, 1, 1,   1, 1, 1, 1],  // 5-
  [1,   1, 1, 1,   1, 1, 1, 0.5],  // #5-
  [1,   1, 1, 1,   1, 1, 1, 0],  // 6- 
  [1,   1, 1, 1,   1, 1, 0, 0],  // #6-
  [1,   1, 1, 1,   1, 0, 1, 0],  // 7-
  [1,   1, 1, 1,   0, 0, 1, 0],  // 1
  [1,   1, 1, 0.5,   0, 0, 1, 0],  // #1
  [1,   1, 1, 0,   0, 0, 1, 0],  // 2
  [1,   1, 0, 0,   0, 0, 1, 0],  // #2
  [1,   0, 1, 0,   0, 0, 1, 0],  // 3
  [0,   1, 1, 1,   0, 0, 1, 0],  // 4
  [0,   0, 1, 0,   0, 0, 1, 0],  // #4

  [1,   1, 1, 1,   1, 1, 1, 1],  // 5
  [1,   1, 1, 1,   1, 1, 1, 0.5],  // #5
  [1,   1, 1, 1,   1, 1, 1, 0],  // 6
  [1,   1, 1, 1,   1, 1, 0, 0],  // #6
  [1,   1, 1, 1,   1, 0, 1, 0],  // 7
  [1,   1, 1, 1,   0, 0, 1, 0],  // 1+
  [1,   1, 1, 0.5,   0, 0, 1, 0],  // #1+
  [1,   1, 1, 0,   0, 0, 1, 0],  // 2+
  [1,   1, 0, 0,   0, 0, 1, 0],  // #2+
  [1,   0, 1, 0,   0, 0, 1, 0],  // 3+
  [0,   1, 1, 1,   1, 1, 1, 0],  // 4+
  [0,   0, 1, 0,   0, 0, 1, 0],  // #4+

  [0,   1, 1, 1,   1, 1, 1, 1],  // 5+
  [1,   1, 1, 0.5,   0, 0, 1, 1],  // #5+
  [1,   1, 1, 0,   0, 0, 1, 1],  // 6+
  [1,   1, 0, 0,   0, 0, 1, 1],  // #6+
  [1,   1, 0, 1,   1, 1, 1, 1],  // 7+
  [1,   0, 1, 1,   1, 0, 1, 1],  // 1++
];

const 指法 = 音 => 指法数据[音 - 1] || [];

const S指法表容器 = styled.div`
  display: inline-flex;
  padding: 40px;
  /* background: #fff; */
  font-weight: 800;
`;

const S占位 = styled.div`
  box-sizing: border-box;
  height: 20px;
  width: 10px;
  flex: none;
`;

const Context = React.createContext({});

export const C洞箫指法表 = () => {
  const [乐器信息, set乐器信息] = useState({
    乐器: 'G',
    筒音基准音: 'D4',
  });
  const [演奏信息, set演奏信息] = useState({
    筒音: '5-',
  });
  const 音域 = 指法数据.length;
  const content = Array(音域)
    .fill()
    .map((_, 音) =>
      指法(音) === [] ? null : <C图示列 key={音 + 1} 音={音 + 1} />
    );
  content.splice(12, 0, <S占位 key={'占位11'} />);
  content.splice(25, 0, <S占位 key={'占位12'} />);
  const contextValue = { ...乐器信息, ...演奏信息 };
  return (
    <Context.Provider value={contextValue}>
      <S指法表容器>{content}</S指法表容器>
    </Context.Provider>
  );
};

const S图示容器 = styled.div`
  flex: none;
  border-radius: 6px;
  overflow: hidden;
  margin: 0 6px;
  box-shadow: 0 2px 4px #0008;
  border: solid .5px #0004;
`;

const borderWidth = 2;
const S通用容器 = styled.div`
  background: #fff;
  /* border: ${borderWidth}px solid #000; */
  /* margin: ${-borderWidth}px ${-borderWidth / 2}px; */
  width: 40px;
  flex: none;
  padding: 10px 0;
`;

const S指法图示容器 = styled(S通用容器)`
  padding: 20px 0 12px;
  background: #00f2;
`;

const S大间隔 = styled.div`
  margin: 8px 0;
`;

const S音名 = styled(S大间隔)`
  color: ${(props) => props.color || '#000'};
  font-weight: ${(props) => (半音(props.children) ? 300 : 'unset')};
`;

const S音编号 = styled.div`
  color: #0005;
`;

const S基准音 = styled(S通用容器)`
  padding: 15px 0;
  background: ${(props) => (半音(props.children) ? '#000' : '#fff')};
  font-weight: ${(props) => (半音(props.children) ? 300 : 'unset')};
  color: ${(props) => (半音(props.children) ? '#fff' : '000')};
`;

const C图示列 = (props) => {
  const { 音 } = props || {};
  return (
    <S图示容器>
      <C上方 音={音} />
      <S指法图示容器>
        <C指法 音={音} />
      </S指法图示容器>
      <C下方 音={音} />
    </S图示容器>
  );
};

const 半音 = (str) => str.slice?.(0, 1) === '#';

const C上方 = (props) => {
  const { 音 } = props;
  const { 筒音 } = useContext(Context);
  return <S基准音>{音名(筒音, 音, 简谱音名表)}</S基准音>;
};

const C指法 = (props) => {
  const { 音 } = props;
  const content = 指法(音).map((孔状态, index) => (
    <C孔 key={index} 状态={孔状态} 保留孔={[2, 6].includes(index)} />
  ));
  content.splice(1, 0, <S占位 key={'占位11'} />);
  content.splice(-4, 0, <S占位 key={'占位12'} />);
  return (
    <div>
      {content}
      <S音编号>{音}</S音编号>
    </div>
  );
};

const C下方 = (props) => {
  const { 音 } = props;
  const { 筒音基准音 } = useContext(Context);
  return (
    <>
      <S基准音>{音名(筒音基准音, 音, 基准音名表)}</S基准音>
    </>
  );
};

const 孔颜色 = (孔状态) => {
  if (孔状态 <= 0) {
    return '#fff';
  } else if (孔状态 >= 1) {
    return '#000';
  } else {
    return '#bbb';
  }
};

const S孔 = styled.div`
  margin: 10px;
  box-sizing: border-box;
  height: 20px;
  border-radius: 99999999px;
  width: 20px;
  border: ${(props) => (props.保留孔 ? '3' : '2')}px solid #000;
  background: ${(props) => 孔颜色(props.状态)};
`;

const C孔 = (props) => <S孔 {...props} />;
